import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/login/Login.vue'
import Main from '../views/main/Main.vue'
import PdfVerify from '../views/PdfVerify.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    meta: {
      title: '检测管理系统登录'
    },
    component: Login
  },
  {
    path: '/main',
    name: 'Main',
    meta: {
      title: '检测管理系统'
    },
    component: Main
  },
  {
    path: '/verfiy',
    name: 'PdfVerify',
    meta: {
      title: 'PDF预览',
      noAuth: true // 标记为不需要登录验证
    },
    component: PdfVerify
  }
]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
  // 如果路由标记了 noAuth,则不需要登录验证
  if (to.path === '/login' || to.meta.noAuth) {
    next()
  } else {
    let token = localStorage.getItem('authorization')
    if (token === null || token === 'null' || token === '') {
      next('/login')
    } else {
      next()
    }
  }
})
export default router
